<script type="text/ecmascript-6">
    import DateRangePicker from "vue2-daterange-picker";
    import axios from "axios";
    import {mapGetters} from "vuex";

    export default {
        components: { DateRangePicker },

        /**
         * The component's data.
         */
        data: () => ({
            dateRange: {
                startDate: '2019-12-10',
                endDate: '2019-12-20',
            },
        }),

        filters: {
            date (value) {
                if (!value)
                    return '';
                let options = {year: 'numeric', month: 'long', day: 'numeric'};
                return Intl.DateTimeFormat('en-US', options).format(value)
            }
        },

        mounted() {
            this.dateRange.startDate = this.moment(this.dateTime.startDate).format('YYYY-MM-DD');
            this.dateRange.endDate = this.moment(this.dateTime.endDate).format('YYYY-MM-DD');

            window.addEventListener("afterprint", () => {
                this.$store.dispatch('setIsPreview',false);
                this.$store.dispatch('setIsPrint',false);
            });
        },

        /**
         * Computed these properties.
         */
        computed: {
            ...mapGetters({
                isLoading: 'getIsLoading',
                isShow: 'getIsShow',
                dateRangeData: 'getDateRangeData',
                dateTime: 'getDateTime',
                isPreview: 'getIsPreview',
                isPrint: 'getIsPrint',
                competitor_ids: 'getCompetitorIds',
                ownPage: 'getOwnPage',
            })
        },

        methods: {

            async getProfilesData() {
                await axios.request({
                    method: 'post',
                    baseURL: process.env.VUE_APP_ROOT_API,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer 6ff28042-50cf-41fe-a557-67a385223d4d'
                    },
                    data: {
                        "jsonrpc": "2.0",
                        "id": 1,
                        "method": "partner_api.get_profiles_data",
                        "params": {
                            "ids": this.competitor_ids,
                            "date": {
                                "start": this.dateTime.startDate,
                                "end": this.dateTime.endDate
                            },
                            "from":0,
                            "size":10
                        }
                    },
                }).then((response) => {

                    this.$store.dispatch('setOwnPageData',response);

                    this.$store.dispatch('setCompetitorBenchmark',response);

                }).catch((error) => {
                    console.log(error);
                    this.$store.dispatch('setIsShow',false);
                    this.$store.dispatch('setIsLoading',false);
                });
            },

            async getPostsForProfile() {
                await axios.request({
                    method: 'post',
                    baseURL: process.env.VUE_APP_ROOT_API,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer 6ff28042-50cf-41fe-a557-67a385223d4d'
                    },
                    data: {
                        "jsonrpc": "2.0",
                        "id": 1,
                        "method": "partner_api.get_posts_for_profile",
                        "params": {
                            "id": this.ownPage.id,
                            "date": {
                                "start": this.dateTime.startDate,
                                "end": this.dateTime.endDate
                            },
                            "from":0,
                            "size":22
                        }
                    },
                }).then((response) => {
                    this.$store.dispatch('setOwnPagePosts',response);
                }).catch(() => {

                });
            },

            async updateValues (values) {
                let dateTime = {
                    startDate : this.moment(values.startDate).startOf('day').valueOf(),
                    endDate : this.moment(values.endDate).endOf('day').valueOf()
                };

                if (dateTime.startDate === this.dateTime.startDate && dateTime.endDate === this.dateTime.endDate) {
                    return 'success';
                }else {
                    await this.$store.dispatch('setDateTime', dateTime);
                    await this.$store.dispatch('setIsLoading',true);

                    await this.getProfilesData();
                    await this.getPostsForProfile();

                    await this.$store.dispatch('setAverageBenchmarks');

                    await this.$store.dispatch('setIsShow',true);
                    await this.$store.dispatch('setIsLoading',false);
                }
            },

            printData() {
                this.$store.dispatch('setIsPrint',true).then( () => {
                    window.print();
                });
            },

            preview(isPreview) {
                this.$store.dispatch('setIsPreview',isPreview);
            },

            async updateBenchmarkData() {
                await this.$store.dispatch('setIsLoading',true);
                await this.getBenchmarkData(this.ownPage);
                await this.$store.dispatch('setIsLoading',false);
            },
        }
    }
</script>

<template>
    <div class="card mb-3" v-show="!isPrint">
        <div class="card-body">
            <div class="row">
                <div class="col-6">
                    <date-range-picker
                            ref="picker"
                            :opens="dateRangeData.opens"
                            :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
                            :minDate="dateRangeData.minDate" :maxDate="dateRangeData.maxDate"
                            :singleDatePicker="false"
                            :showWeekNumbers="true"
                            :showDropdowns="true"
                            :autoApply="false"
                            v-model="dateRange"
                            @update="updateValues"
                            :linkedCalendars="true"
                    >
                        <template v-slot:input="picker" style="min-width: 350px;min-height: 35px">
                            <i class="fas fa-calendar-week fa-lg pr-2"></i>
                            {{ picker.startDate | date }} - {{ picker.endDate | date }}
                            <i class="fa fa-caret-down fa-lg pl-2"></i>
                        </template>
                    </date-range-picker>
                </div>

                <div class="col-6">
                    <button class="btn btn-primary float-right ml-3" @click="updateBenchmarkData()" v-show="$route.name === 'home'"> Update</button>
                    <button class="btn btn-primary float-right" @click="preview(true)" v-show="!isPreview"> Preview</button>
                    <button class="btn btn-primary float-right" @click="printData()" v-show="isPreview"> Print</button>
                    <button class="btn btn-danger float-right mr-3" @click="preview(false)" v-show="isPreview"> Cancel</button>
                </div>
            </div>
        </div>
    </div>
</template>
